module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-32.3d10a921.svg";